<!--
 * @Author: your name
 * @Date: 2021-08-10 17:10:04
 * @LastEditTime: 2021-08-11 13:57:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ndj_share_page\src\views\activity\index.vue
-->
<template>
    <div class="activity-wrap">
        <div class="img-wrap">
            <img src="@/assets/image/activity/1.png" alt="" class="img" />
            <img :src="isApply ? successBtn : applyBtn" alt="" class="btn-img" @click="handleApply" />
        </div>
        <img src="@/assets/image/activity/2.png" alt="" class="img" />
    </div>
</template>
<script>
    export default {
        name: "activity",
        data() {
            return {
                isApply: false, //是否报名
                applyBtn: require("@/assets/image/activity/3.png"),
                successBtn: require("@/assets/image/activity/4.png"),
                userId: "",
            };
        },
        mounted() {
            this.userId = this.$route.query.userId;
            if (this.userId) {
                this.getActivityStatus();
            }
        },
        methods: {
            // 报名
            handleApply() {
                if (this.isApply) {
                    return;
                }
                if(!this.userId){
                    this.$toast("用户Id不能为空!");
                    return;
                }
                this.$api.activityApply({ userId: this.userId, actionEnum: "REGISTER_ONLINE" }).then(res => {
                    this.$toast("报名成功!");
                    this.isApply = true;
                });
            },
            // 详情
            getActivityStatus() {
                this.$api.getActivityStatus({ userId: this.userId, actionEnum: "REGISTER_ONLINE" }).then(res => {
                    if (res.data >= 1) {
                        this.isApply = true;
                    } else {
                        this.isApply = false;
                    }
                });
            },
        },
    };
</script>
<style lang="scss" scoped>
    .activity-wrap {
        .img-wrap {
            position: relative;
        }
        .img {
            width: 100%;
            display: block;
        }
        .btn-img {
            position: absolute;
            width: 60%;
            position: absolute;
            left: 50%;
            bottom: 22px;
            -webkit-transform: translate3d(-50%, 0, 0);
            -moz-transform: translate3d(-50%, 0, 0);
            -ms-transform: translate3d(-50%, 0, 0);
            transform: translate3d(-50%, 0, 0);
        }
    }
</style>
